<script>
  import CheckBox from "./CheckBox.svelte";
  import { TextInput } from "paxray-components-svelte";
  import TimePickerInput from "./TimePickerInput.svelte";
  export let row = {
    zeit: "",
    aufwand: "",
    protocol: "",
    vj: "",
    aufwandspos: "",
    zuordnung: "",
    ma: "",
    objekt: "",
    datum: "",
    abr: false,
    kommentar: "",
    id: "",
  };

  let timeVon = "";
  let timeBis = "";

  function zeitVonBis() {
    if (row.zeit) {
      timeVon = row.zeit.split("-")[0];
      timeBis = row.zeit.split("-")[1];
    } else {
      timeVon = "";
      timeBis = "";
    }
  }

  $: {
    if (row.id) {
      zeitVonBis();
    }
  }

  $: {
    if (row.zeit) {
      zeitVonBis();
    }
  }

  $: row.zeit = `${timeVon}-${timeBis}`;
  $: row.protocol = calculateProtocol(row.zeit);

  function calculateProtocol(zeit) {
    if (!zeit) {
      return "-";
    }
    const [start, end] = zeit.split("-");
    if (isValidTime(start, end)) {
      const [startHour, startMinute] = start.split(":").map(Number);
      const [endHour, endMinute] = end.split(":").map(Number);

      let totalMinutes =
        endHour * 60 + endMinute - (startHour * 60 + startMinute);
      if (totalMinutes < 0) {
        totalMinutes += 24 * 60;
      }
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return `${hours}h ${minutes}min`;
    } else {
      return "-";
    }
  }

  function isValidTime(von, bis) {
    const timePattern = "^([01]\\d|2[0-3]):([0-5]\\d)$";
    return von.match(timePattern) && bis.match(timePattern);
  }
</script>

<form id="timeForm">
  <div class="form-grid">
    <div style="width: fit-content;">
      <TimePickerInput
        required
        label="Wert Std"
        bind:von={timeVon}
        bind:bis={timeBis}
        id="zeit"
        rowId={row.id}
      />
    </div>
    <TextInput
      labelText="Mandant"
      labelLarge
      size="medium"
      id="aufwand"
      placeholder={row.aufwand}
      required
      bind:value={row.aufwand}
    />
    <TextInput
      labelText="Aufwand"
      labelLarge
      size="medium"
      id="protocol"
      unChanged
      value={row.protocol}
    />
    <TextInput
      labelText="VJ"
      id="vj"
      labelLarge
      size="medium"
      placeholder={row.vj}
      bind:value={row.vj}
    />
    <TextInput
      labelText="Aufwandspos"
      labelLarge
      size="medium"
      id="aufwandspos"
      placeholder={row.aufwandspos}
      required
      bind:value={row.aufwandspos}
    />
    <TextInput
      labelText="Zuordnung"
      labelLarge
      size="medium"
      id="zuordnung"
      placeholder={row.zuordnung}
      bind:value={row.zuordnung}
    />
    <TextInput
      labelText="Mitarbeiter"
      labelLarge
      size="medium"
      id="ma"
      placeholder={row.ma}
      required
      bind:value={row.ma}
    />
    <TextInput
      labelText="Objekt"
      labelLarge
      size="medium"
      id="objekt"
      placeholder={row.objekt}
      bind:value={row.objekt}
    />
    <TextInput
      date={true}
      labelText="Datum"
      labelLarge
      size="medium"
      id="datum"
      placeholder={row.datum}
      bind:value={row.datum}
    />
    <div>
      <CheckBox label="Abr.bar" id="abr" key="abr" bind:value={row.abr} />
    </div>
  </div>
  <TextInput
    labelText="Kommentar"
    labelLarge
    size="medium"
    id="kommentar"
    placeholder={row.kommentar}
    required
    bind:value={row.kommentar}
  />
</form>

<style>
  .form-grid {
    display: grid;
    gap: 1rem;
    margin-bottom: 1.5rem;
    margin-top: 1.5rem;
    grid-template-columns: repeat(2, 1fr);
  }

  form {
    margin-bottom: 3rem;
  }
</style>
